/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Wrapped_Summary_RecordsInputs */

const en_us2_wrapped_summary_records = /** @type {(inputs: Wrapped_Summary_RecordsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Plus 1 personal record.`);
	return /** @type {LocalizedString} */ (`Plus ${i?.count} personal records.`)
	
};

const pt_br2_wrapped_summary_records = /** @type {(inputs: Wrapped_Summary_RecordsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`E 1 recorde pessoal batido.`);
	return /** @type {LocalizedString} */ (`E ${i?.count} recordes pessoais batidos.`)
	
};

const es_419_wrapped_summary_records = /** @type {(inputs: Wrapped_Summary_RecordsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Y 1 récord personal.`);
	return /** @type {LocalizedString} */ (`Y ${i?.count} récords personales.`)
	
};

const pt_pt2_wrapped_summary_records = /** @type {(inputs: Wrapped_Summary_RecordsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`E 1 recorde pessoal batido.`);
	return /** @type {LocalizedString} */ (`E ${i?.count} recordes pessoais batidos.`)
	
};

const fr_fr2_wrapped_summary_records = /** @type {(inputs: Wrapped_Summary_RecordsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Et 1 record personnel battu.`);
	return /** @type {LocalizedString} */ (`Et ${i?.count} records personnels battus.`)
	
};

const de_de2_wrapped_summary_records = /** @type {(inputs: Wrapped_Summary_RecordsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Dazu 1 persönlicher Rekord.`);
	return /** @type {LocalizedString} */ (`Dazu ${i?.count} persönliche Rekorde.`)
	
};

const it_it2_wrapped_summary_records = /** @type {(inputs: Wrapped_Summary_RecordsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`In più, 1 record personale.`);
	return /** @type {LocalizedString} */ (`In più, ${i?.count} record personali.`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "Plus 1 personal record." |
* | * | "Plus {count} personal records." |
*
* @param {Wrapped_Summary_RecordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_summary_records = /** @type {((inputs: Wrapped_Summary_RecordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Summary_RecordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_summary_records(inputs)
	if (locale === "es-419") return es_419_wrapped_summary_records(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_summary_records(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_summary_records(inputs)
	if (locale === "de-DE") return de_de2_wrapped_summary_records(inputs)
	if (locale === "it-IT") return it_it2_wrapped_summary_records(inputs)
	return en_us2_wrapped_summary_records(inputs)
});
export { wrapped_summary_records as "wrapped.summary_records" }